/**
 * Constructor de avisos. Separado de `Aviso.tsx` por `react-refresh`: un
 * módulo que exporta componentes no debe exportar otra cosa (§2.3).
 */

export type TonoAviso = 'ok' | 'error' | 'atencion' | 'info';

export interface Mensaje {
  readonly id: string;
  readonly tono: TonoAviso;
  readonly texto: string;
}

let contador = 0;

export const mensaje = (tono: TonoAviso, texto: string): Mensaje => ({
  id: `m${(contador += 1)}`,
  tono,
  texto,
});
